import notify from 'devextreme/ui/notify';

let toastAnchorSelector = '.app-shell-main';

export interface ConfigureAppToastsOptions {
  anchorSelector?: string;
}

export function configureAppToasts(options: ConfigureAppToastsOptions = {}): void {
  if (options.anchorSelector) {
    toastAnchorSelector = options.anchorSelector;
  }
}

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export function showToast(message: string, type: ToastType, displayTime?: number): void {
  const defaultDisplayTime =
    type === 'error' ? 8000 : type === 'warning' ? 7000 : 3500;
  notify({
    message,
    type,
    displayTime: displayTime ?? defaultDisplayTime,
    width: 'auto',
    minWidth: 560,
    maxWidth: 760,
    position: {
      my: 'bottom right',
      at: 'bottom right',
      of: toastAnchorSelector,
      offset: '-16 -16'
    }
  });
}

export function showSuccessToast(message: string): void {
  showToast(message, 'success');
}

export function showErrorToast(message: string): void {
  showToast(message, 'error');
}

export function showWarningToast(message: string): void {
  showToast(message, 'warning');
}

export function showInfoToast(message: string): void {
  showToast(message, 'info');
}
